// Angular
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { SelectOptionsService } from '@app/shared/services/select-options.service'
import { Uri } from '@app/modules/uri/uri.model'
import { UriFormService } from '@app/modules/uri/uri-form.service'
import { DeleteIdFormService } from '@app/modules/delete-id/delete-id-form.service'
import { ValidationService } from '@app/shared/services/validation.service'

@Component({
  selector: 'app-uris-form-array',
  templateUrl: './uris-form-array.component.html'
})

export class UrisFormArrayComponent implements OnInit, OnDestroy {

  /**
   * Display page
   */
  public display: boolean

  /**
   * Heading text
   */
  @Input() headingText: string

  /**
   * Button text
   */
  @Input() buttonText: string

  /**
   * Main form
   */
  @Input() mainForm: FormGroup

  /**
   * Main form change
   */
  @Output() mainFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  /**
   * Constructor
   */
  public constructor (
    public selectOptionsService: SelectOptionsService,
    private uriFormService: UriFormService,
    private deleteIdFormService: DeleteIdFormService,
    public validationService: ValidationService
  ) {}

  /**
   * On destroy
   */
  public ngOnDestroy (): void {}

  /**
   * On init
   */
  public ngOnInit (): void {
    this.display = true
  }

  /**
   * Add uri
   */
  public add (): void {
    const control: FormArray = this.mainForm.get('uris') as FormArray
    const uri: Uri = new Uri()
    const form: FormGroup = this.uriFormService.getForm(uri, 'new')
    control.push(form)
    this.mainForm.markAsDirty()
  }

  /**
   * Remove
   *
   * @param {FormGroup} item Uri
   */
  public remove (item: FormGroup): void {
    const control: FormArray = this.mainForm.get('uris') as FormArray
    const index: number = control.controls.findIndex(x => x === item)
    const uri: Uri = new Uri(item.value)

    if (uri.uuid) {
      // Mark it for delete.
      const deleted: FormArray = this.mainForm.get('uris') as FormArray
      deleted.push(this.deleteIdFormService.getForm({ uuid: uri.uuid }))
    }

    control.removeAt(index)
    this.mainForm.markAsDirty()
  }

}
